import React from 'react';

const PostCardSkeleton = () => (
  <div className='flex flex-col'>
    {/* Date and Time skeleton */}
    <div className='mb-2 px-1 flex items-center justify-between'>
      <div className='h-4 bg-gray-200 rounded w-32'></div>
      <div className='h-5 bg-gray-200 rounded-full w-16'></div>
    </div>
    {/* Card skeleton */}
    <div className='w-full p-4 bg-gray-50 rounded-lg border-2 border-gray-200'>
      <div className='w-full h-64 bg-gray-200 rounded-lg'></div>
    </div>
  </div>
);

export default PostCardSkeleton;
